import { render, staticRenderFns } from "./ShablonRecipe.vue?vue&type=template&id=91aaa9ae"
import script from "./ShablonRecipe.vue?vue&type=script&lang=js"
export * from "./ShablonRecipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports